import { useContext } from "react";
import { ModalStackContext } from "./context";
export const useModalStack = () => {
    const context = useContext(ModalStackContext);
    if (!context) {
        throw new Error("useModalStack called without an enclosing ModalStack component");
    }
    return context;
};
